import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class ErrorService {
    constructor() {
    }

    handleError(error: any) {
        let responseError = (error && error._body);
        let errorObj = JSON.parse(responseError);
        return Observable.throw(errorObj);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/error.service.ts